'use client';

import { FC, useState } from 'react';
import { Link, Typography } from '@mui/material';
import { UserViewDialog } from '@/components/dialog/UserViewDialog';

interface UserLinkProps {
  userId: string;
  displayText: string;
}

export const UserLink: FC<UserLinkProps> = ({ userId, displayText }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setDialogOpen(true);
  };

  return (
    <>
      <Link
        component="button"
        variant="body2"
        onClick={handleClick}
        sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {displayText}
      </Link>
      <UserViewDialog open={dialogOpen} userId={userId} onClose={() => setDialogOpen(false)} />
    </>
  );
};

interface UserLinksProps {
  userIds: string[];
  displayTexts: string[];
  separator?: string;
}

export const UserLinks: FC<UserLinksProps> = ({ userIds, displayTexts, separator = ', ' }) => {
  if (!userIds || userIds.length === 0) {
    return <Typography variant="body2">N/A</Typography>;
  }

  return (
    <>
      {userIds.map((userId, index) => (
        <span key={userId}>
          <UserLink userId={userId} displayText={displayTexts[index] || userId} />
          {index < userIds.length - 1 ? <span>{separator}</span> : null}
        </span>
      ))}
    </>
  );
};

export default UserLink;
